(function () {
  function refreshHeaderCartIcon() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;

    fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionEl = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('[id^="shopify-section-"]');
        if (sectionEl) link.innerHTML = sectionEl.innerHTML;
      })
      .catch(function () {});
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (!format) return '$' + amount;
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_with_space_separator}}', amount.replace('.', ' '));
  }

  // Reads the live selected variant from the main variant picker above, so
  // "Add to cart" adds whichever color the customer currently has selected.
  function currentBaseVariantId(root) {
    var infoContainer = root.closest('.product__info-container') || document;
    var variantSelects = infoContainer.querySelector('variant-selects');
    var script = variantSelects ? variantSelects.querySelector('[data-selected-variant]') : null;
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (parsed && parsed.id) return String(parsed.id);
      } catch (e) {}
    }
    return root.dataset.baseVariantId;
  }

  function initAddon(root) {
    if (root.dataset.geminiAddonReady === 'true') return;
    root.dataset.geminiAddonReady = 'true';

    var moneyFormat = root.dataset.moneyFormat;
    var addonVariantId = root.dataset.addonVariantId;
    var checkbox = root.querySelector('[data-gemini-addon-checkbox]');
    var quantityWrap = root.querySelector('[data-gemini-addon-quantity-wrap]');
    var quantityInput = root.querySelector('[data-gemini-addon-quantity]');
    var priceEl = root.querySelector('[data-gemini-addon-price]');
    var ctaButton = root.querySelector('[data-gemini-addon-submit]');
    var infoContainer = root.closest('.product__info-container') || document;
    var baseQuantityInput = infoContainer.querySelector('.quantity__input, input[name="quantity"]');

    var unitPrice = priceEl ? parseInt(priceEl.dataset.unitPrice, 10) : 0;

    function selectedBaseQuantity() {
      var value = baseQuantityInput ? parseInt(baseQuantityInput.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    function selectedAddonQuantity() {
      var value = quantityInput ? parseInt(quantityInput.value, 10) : 2;
      return value > 0 ? value : 2;
    }

    function updatePrice() {
      if (!priceEl) return;
      priceEl.textContent = '+ ' + formatMoney(unitPrice, moneyFormat) + '/ea';
    }

    function syncQuantityVisibility() {
      if (!quantityWrap) return;
      quantityWrap.classList.toggle('is-expanded', !!(checkbox && checkbox.checked));
    }

    if (checkbox) {
      checkbox.addEventListener('change', syncQuantityVisibility);
    }

    syncQuantityVisibility();
    updatePrice();

    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        if (ctaButton.getAttribute('aria-disabled') === 'true') return;

        var baseVariantIdNow = currentBaseVariantId(root);
        var items = [{ id: baseVariantIdNow, quantity: selectedBaseQuantity() }];

        if (checkbox && checkbox.checked) {
          items.push({ id: addonVariantId, quantity: selectedAddonQuantity() });
        }

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var bodyData = { items: items };
        if (cart) {
          bodyData.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          bodyData.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }

        ctaButton.setAttribute('aria-disabled', 'true');
        ctaButton.classList.add('loading');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(bodyData),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function (response) {
            if (typeof window.SLIDECART_UPDATE === 'function') {
              window.SLIDECART_UPDATE(function () {
                if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
                refreshHeaderCartIcon();
              });
            } else if (cart) {
              cart.classList.remove('is-empty');
              cart.renderContents(response);
              refreshHeaderCartIcon();
            } else {
              refreshHeaderCartIcon();
            }
          })
          .catch(function () {})
          .finally(function () {
            ctaButton.removeAttribute('aria-disabled');
            ctaButton.classList.remove('loading');
          });
      });
    }
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-gemini-addon]').forEach(initAddon);
  }

  setupAll();

  // The main variant picker re-renders the product info column on change
  // (Dawn's standard AJAX section refresh), which can replace this module's
  // markup wholesale — watch for that and re-run setup so listeners stay attached.
  var infoContainers = document.querySelectorAll('.product__info-container');
  if (window.MutationObserver && infoContainers.length) {
    infoContainers.forEach(function (container) {
      new MutationObserver(function () {
        setupAll(container);
      }).observe(container, { childList: true, subtree: true });
    });
  }
})();
